module.exports = __webpack_public_path__ + "static/media/books.ca66cd95.png";